export default [
  {
    path: "generate-token",
    name: "generate-token",
    component: () => import("@/views/integrator/GenerateToken.vue"),
  }
];
